import Main from '@/views/Main.vue'

import accountRoutes from '@/routes/account'
import billingRoutes from '@/routes/billing'
import iamRoutes from '@/routes/iam'
import nodesRoutes from '@/routes/nodes'
import publicRoutes from '@/routes/public'
import supportRoutes from '@/routes/support'

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/',
        name: 'console',
        meta: { menu: 'console' },
        component: () =>
          import(/* webpackChunkName: 'main' */ '@/views/Console.vue')
      },

      ...accountRoutes,
      ...supportRoutes,
      ...billingRoutes,
      ...nodesRoutes,
      ...iamRoutes,
      {
        path: '/logout',
        name: 'logout',
        component: () =>
          import(/* webpackChunkName: 'logout' */ '@/views/LogOut.vue')
      }
    ]
  },

  ...publicRoutes,

  {
    path: '*',
    name: 'not-found',
    component: () =>
      import(/* webpackChunkName: 'main' */ '@/views/NotFound.vue')
  }
]

export default routes
